<div class="breadcrumb-container" [ngClass]="{ 'breadcrumb-container-compact': compactSidebar }" id="breadcrumb">
  <div class="breadcrumb-component">
    <app-breadcrumb
      [parents]="breadcrumbParents"
      [self]="breadcrumbSelf">
    </app-breadcrumb>
  </div>
  <app-breadcrumb-menu>
    <app-breadcrumb-button
      [iconClass]="'icomoon-download'"
      [titleStringKey]="'COMMON_EXPORT_XLSX'"
      (click)="exportXlsx()">
    </app-breadcrumb-button>
  </app-breadcrumb-menu>
</div>
<div class="breadcrumb-placeholder"></div>
<div class="container-horizontal-padding container-vertical-padding animated fadeIn">

  <div class="card">

    <div class="card-header cursor-pointer" (click)="toggleSearch()">
      {{'MENU_NAVBAR_TASK_STATISTICS' | translate}}

      <div class="card-actions">
        <a class="btn-setting" title="{{'COMMON_SHOW_SEARCH_HINT' | translate}}"><i #searchIcon
                                                                                    class="icomoon icomoon-search"></i></a>
      </div><!-- /.card-actions -->
    </div>

    <div class="card-body border-bottom" *ngIf="showSearch" appHighlightContainer>

      <div class="row form-group">
        <div class="col-sm-3">
          <label class="search-label">{{'TASK_RECORD_SEARCH_TASK_NAME' | translate}}</label>
          <angular2-multiselect [data]="tasksForSearch" [settings]="dropdownSettingsForMultiWithRemoteSearch"
                                class="form-control"
                                [(ngModel)]="searchModel.task"
                                (onRemoteSearch)="onTaskSearch($event.target.value)"
                                #taskName="ngModel" name="taskName" id="taskName">
          </angular2-multiselect>
        </div>

        <div class="col-sm-3">
          <label class="search-label">{{'TASK_RECORD_SEARCH_USER_NAME' | translate}}</label>
          <angular2-multiselect [data]="usersForSearch" [settings]="dropdownSettingsForMultiWithRemoteSearch"
                                class="form-control"
                                [(ngModel)]="searchModel.user"
                                (onRemoteSearch)="onUserSearch($event.target.value)"
                                #userMulti="ngModel" name="userMulti" id="userMulti">
          </angular2-multiselect>
        </div>

        <div class="col-md-3">
          <label class="search-label">{{'COMMON_SEARCH_INTERVAL_FROM' | translate}}</label>
          <div class="row">
            <div class="input-group col-md-7 pr-md-0">
              <input type="text" class="form-control date"
                     placeholder="{{'COMMON_SEARCH_INTERVAL_FROM' | translate}}"
                     [(ngModel)]="searchModel.fromDate"
                     ngbDatepicker
                     name="fromDate"
                     id="fromDate"
                     #fromDate="ngbDatepicker">
              <div class="input-group-addon-gray" (click)="fromDate.toggle()">
                <i class="icomoon icomoon-calendar"></i>
              </div>
            </div>
            <div class="input-group col-md-5 p-md-0">
              <input type="text" class="form-control time"
                     [(ngModel)]="searchModel.fromTime"
                     ngbTimepicker
                     name="fromTime"
                     id="fromTime"
                     [seconds]="false"
                     [allowEmptyValue]="true"
                     [spinners]="true" [hourStep]="1" [minuteStep]="10"
                     [disabled]="searchModel.fromDate === null"
                     [toggleButtonId]="'fromTime_button'"
                     #fromTime="ngbTimepicker">
              <div class="input-group-addon-gray"
                   id="fromTime_button"
                   (click)="fromTime.toggle()">
                <i class="icomoon icomoon-time"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <label class="search-label">{{'COMMON_SEARCH_INTERVAL_TO' | translate}}</label>
          <div class="row">
            <div class="input-group col-md-7 pr-md-0">
              <input type="text" class="form-control date"
                     placeholder="{{'COMMON_SEARCH_INTERVAL_TO' | translate}}"
                     [(ngModel)]="searchModel.toDate"
                     ngbDatepicker
                     name="toDate"
                     id="toDate"
                     #toDate="ngbDatepicker">
              <div class="input-group-addon-gray" (click)="toDate.toggle()">
                <i class="icomoon icomoon-calendar"></i>
              </div>
            </div>
            <div class="input-group col-md-5 p-md-0">
              <input type="text" class="form-control time"
                     [(ngModel)]="searchModel.toTime"
                     ngbTimepicker
                     name="toTime"
                     id="toTime"
                     [seconds]="false"
                     [allowEmptyValue]="true"
                     [spinners]="true" [hourStep]="1" [minuteStep]="10"
                     [disabled]="searchModel.toDate === null"
                     [toggleButtonId]="'toTime_button'"
                     #toTime="ngbTimepicker">
              <div class="input-group-addon-gray"
                   id="toTime_button"
                   (click)="toTime.toggle()">
                <i class="icomoon icomoon-time"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12 d-flex justify-content-md-end align-items-end pr-1 pl-0">
          <div class="btn-group" role="group">
            <button type="button" (click)="onSearchReset()" class="btn btn-outline-primary search-button mr-1">
              {{'COMMON_BUTTON_SEARCH_DELETE' | translate}}
            </button>
            <button type="button" (click)="onSearchClicked()" class="btn btn-primary search-button">
              {{'COMMON_BUTTON_SEARCH' | translate}}
            </button>
          </div>
        </div>
      </div>

    </div><!-- /.card-body-->

    <div class="card-body">

      <table class="table table-striped table-bordered">
        <thead>
        <tr>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.TASK_NAME"
                                    [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.TASK_NAME)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_TASK_TYPE' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.USER_PERSON_NAME"
                                    [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.USER_PERSON_NAME)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'AUDIT_LOG_TABLE_HEADER_USER_NAME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.CREATE_COUNT"
                                    [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.CREATE_COUNT)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'TASK_STATISTICS_TABLE_HEADER_CREATE_COUNT' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-md-down w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.OPEN_COUNT"
                                    [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.OPEN_COUNT)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'TASK_STATISTICS_TABLE_HEADER_OPEN_COUNT' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.START_COUNT"
                                    [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.START_COUNT)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'TASK_STATISTICS_TABLE_HEADER_START_COUNT' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-lg-down w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.REJECT_COUNT"
                                    [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.REJECT_COUNT)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'TASK_STATISTICS_TABLE_HEADER_REJECT_COUNT' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-lg-down w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.RECALL_COUNT"
                                    [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.RECALL_COUNT)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'TASK_STATISTICS_TABLE_HEADER_RECALL_COUNT' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.FINISH_COUNT"
                                    [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.FINISH_COUNT)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'TASK_STATISTICS_TABLE_HEADER_FINISH_COUNT' | translate"></app-table-field-sorter>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let model of taskStatistics | paginate: {
                                                      itemsPerPage: queryModel.itemsPerPage,
                                                      currentPage: queryModel.currentPage,
                                                      totalItems: queryModel.currentNumberOfItems }; index as i"
            appTableColoredRow
            [colorIndex]="getColorIndex(model.taskData)"
            [rowIndex]="i"
            id="task-record-list-row-{{i}}">
          <td class="responsive-table-column"><div class="d-flex flex-wrap">
            <app-type-icon class="mr-05" [icon]="getTaskIcon(model.taskData)"></app-type-icon>
            <span class="text-break">{{getTaskName(model.taskData)}}</span></div></td>
          <td class="responsive-table-column">{{getUserName(model.userData)}}</td>
          <td class="responsive-table-column ">{{model.statistics.createCount}}</td>
          <td class="responsive-table-column hidden-md-down">{{model.statistics.openCount}}</td>
          <td class="responsive-table-column ">{{model.statistics.startCount}}</td>
          <td class="responsive-table-column hidden-lg-down">{{model.statistics.rejectCount}}</td>
          <td class="responsive-table-column hidden-lg-down">{{model.statistics.recallCount}}</td>
          <td class="responsive-table-column ">{{model.statistics.finishCount}}</td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.TASK_NAME"
                              [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.TASK_NAME)"
                              (orderChange)="orderBy($event)"
                              [text]="'COMMON_TASK_TYPE' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.USER_PERSON_NAME"
                              [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.USER_PERSON_NAME)"
                              (orderChange)="orderBy($event)"
                              [text]="'AUDIT_LOG_TABLE_HEADER_USER_NAME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.CREATE_COUNT"
                              [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.CREATE_COUNT)"
                              (orderChange)="orderBy($event)"
                              [text]="'TASK_STATISTICS_TABLE_HEADER_CREATE_COUNT' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-md-down w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.OPEN_COUNT"
                              [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.OPEN_COUNT)"
                              (orderChange)="orderBy($event)"
                              [text]="'TASK_STATISTICS_TABLE_HEADER_OPEN_COUNT' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.START_COUNT"
                              [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.START_COUNT)"
                              (orderChange)="orderBy($event)"
                              [text]="'TASK_STATISTICS_TABLE_HEADER_START_COUNT' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-lg-down w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.REJECT_COUNT"
                              [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.REJECT_COUNT)"
                              (orderChange)="orderBy($event)"
                              [text]="'TASK_STATISTICS_TABLE_HEADER_REJECT_COUNT' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-lg-down w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.RECALL_COUNT"
                              [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.RECALL_COUNT)"
                              (orderChange)="orderBy($event)"
                              [text]="'TASK_STATISTICS_TABLE_HEADER_RECALL_COUNT' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-10">
            <app-table-field-sorter [orderField]="TaskStatistics.OrderField.FINISH_COUNT"
                              [orderType]="queryModel.getOrderType(TaskStatistics.OrderField.FINISH_COUNT)"
                              (orderChange)="orderBy($event)"
                              [text]="'TASK_STATISTICS_TABLE_HEADER_FINISH_COUNT' | translate"></app-table-field-sorter>
          </th>
        </tr>
        </tfoot>
      </table>
      <app-table-paging
        [currentNumberOfItems]="queryModel.currentNumberOfItems"
        [totalNumberOfItems]="queryModel.totalNumberOfItems"
        [itemsPerPage]="queryModel.itemsPerPage"
        (pageChange)="pageChanged($event)"
        [hideNumberOfItems]="true"
        (itemsPerPageChange)="itemsPerPageChanged($event)">
      </app-table-paging>

    </div><!-- /.card-body -->
  </div><!-- /.card-->
</div>
